{% block swag_migration_index_main_page %}
    <div class="swag-migration-index-main-page">

        {% block swag_migration_index_main_page_content %}
            <div v-if="!isLoading">

                {% block swag_migration_index_main_page_warnings %}
                    <div class="swag-migration-index-main-page__warnings">
                        <template
                            v-for="warning in displayWarnings"
                            :key="warning.snippetKey"
                        >

                            <mt-banner
                                class="swag-migration-index-main-page__warning"
                                variant="attention"
                            >
                                {{ $tc(warning.snippetKey, warning.snippetArguments, warning.pluralizationCount) }}
                            </mt-banner>
                        </template>
                    </div>
                {% endblock %}

                {% block swag_migration_index_main_page_card_shopInformation %}
                    <swag-migration-shop-information :connected="connectionEstablished" />
                {% endblock %}
            </div>
        {% endblock %}

        {% block swag_migration_index_main_page_loader %}
            <mt-loader v-if="isLoading" />
        {% endblock %}
    </div>
{% endblock %}
